import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { DashboardService } from "../../../services/dashboard.service";
import { AlertService } from "ngx-alerts";
import { LOCAL_STORAGE, StorageService } from "ngx-webstorage-service";
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from "rxjs/operators";
import { DatePipe, DOCUMENT } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTabGroup } from "@angular/material/tabs";
import { Observable } from "rxjs";
import { AgmMap } from "@agm/core";
import { AgmDrawingManager } from "@agm/drawing";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from "@angular/cdk/layout";
import { ActivatedRoute } from "@angular/router";
import { SocketIoService } from "../../../services/socket-io.service";

declare const google: any;

@Component({
  selector: "app-map-dashboard",
  templateUrl: "./map-dashboard.component.html",
  styleUrls: ["./map-dashboard.component.scss"],
})
export class MapDashboardComponent implements OnInit, OnDestroy {
  carSearchInputFocus: boolean = false;

  @ViewChild("matTabGroup", { static: false }) matTabGroup: MatTabGroup;

  availableCars = [];
  selectedCar: any;

  drivingAlertsDateRange: any = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  loggedInUser: any;
  channelId: any = "";
  driverVehiclesSearch = {
    channelId: "",
    page: 0,
    size: 99,
    search: "",
  };
  centerVehicle: { lat: number; lng: number };

  vehicleAlertsSearch = {
    isActiveAlerts: true,
    size: 10,
    page: 0,
  };
  selectedVehicleAlerts: any[] = [];
  selectedVehicleUserDrivingAnalytics: any;
  selectedVehicleLiveLocation: any = "";
  isVehicleAlertsCardCollapsed: boolean = false;
  isMainMenuCollapsed: boolean = true;

  elem: any;
  navElem: any;
  isFullScreenEnabled: boolean = false;

  //driving alerts
  totalDrivingAlerts = 0;
  selectedVehicleDrivingAlerts: any[] = [];
  drivingAlertsSearch = {
    vehicleId: "",
    search: "",
    periodFrom: "",
    periodTo: "",
    size: 20,
    page: 0,
  };

  //trips
  tripsDateRange: any = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  selectedCarTrips: any;
  selectedCarTripsTotalRecord = 0;
  tripsSearch = {
    size: 10,
    page: 0,
    vehicleId: "",
    isFleetView: true,
    periodFrom: "",
    periodTo: "",
    isBasic: true,
    isVHSReport: false,
  };
  lastTripSearch = {
    size: 1,
    page: 0,
    isShowInValidTrips: true,
    isAllTrips: true,
  };
  selectedTrip: any;
  sub: any;
  mainSub: any;
  tripLatLongs: any[] = [];
  public flightPlanCoordinates: any[] = [];
  selectedTripDrivingAlerts: any[] = [];
  selectedTripVehicleAlerts: any[] = [];
  selectedTripLiveLocationDetails: any;

  lastTripData: any;

  //geo fencing

  @ViewChild("agmMap") agmMap: ElementRef;
  @ViewChild("agmDrawingManager") agmDrawingManager: AgmDrawingManager;

  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  );

  queryVehicleId: any;

  constructor(
    private dashboardService: DashboardService,
    private alertService: AlertService,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private spinner: NgxSpinnerService,
    @Inject(DOCUMENT) private document: any,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private socketIoService: SocketIoService
  ) {
    this.loggedInUser = storage.get("gs-loggedInUser");

    this.channelId = this.loggedInUser.channelId;
    this.driverVehiclesSearch.channelId = this.channelId;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((res: any) => {
      this.queryVehicleId = res.vehicleId;
      this.getAllDriverVehicles(false);
    });
    // reset the height whenever the window's resized
    window.addEventListener("resize", this.resetHeight);
    // called to initially set the height.
    this.resetHeight();
    this.elem = document.documentElement;
    this.getAllDriverVehicles(true);

    this.sub = Observable.interval(120000).subscribe((val) => {
      this.getAllDriverVehicles(true, true);
    });
    this.isMedium.subscribe((size) => {
      if (size.matches) {
        document.getElementById("vertical-menu-btn").click();
      }
    });

    this.socketIoService.onMessageReceive().subscribe((res: any) => {
      if (res instanceof Object) {
        if (res.echo) {
          if (this.selectedCar) {
            this.socketIoService.joinRoom(this.selectedCar.userVehicleId);
          }
        }
        if (res.vehicleId) {
          this.availableCars.forEach((av, index) => {
            if (av.userVehicleId == res.vehicleId) {
              // let deltalat = (Number(res.lat) - av.latitude) / 10;
              // let deltalng = (Number(res.lng) - av.longitude) / 10;
              //
              // for (let i = 0; i < 10; i++) {
              //   ((ind) => {
              //     setTimeout(
              //       () => {
              //         let lat = av.latitude;
              //         let lng = av.longitude;
              //
              //         lat += deltalat;
              //         lng += deltalng;
              //         console.log('coming');
              //         av['latitude'] = +lat;
              //         av['longitude'] = +lng;
              //         av['lastUpdatedOn'] = res.createdOn;
              //         this.availableCars[index] = av;
              //       }, 10 * ind
              //     );
              //   })(i);
              // }
              av["latitude"] = +res.lat;
              av["longitude"] = +res.lng;
              av["lastUpdatedOn"] = res.createdOn;
              av["bearing"] = res.bearing;
              av["speed"] = res.speed;
              this.availableCars[index] = av;
            }
          });
        }
      }
      console.log("message received: ");
      console.log(res);
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.mainSub) {
      this.mainSub.unsubscribe();
    }
  }

  onCarCheckBoxClick(car: any, isForceSelect?: boolean) {
    if (this.selectedCar) {
      this.socketIoService.leaveRoom(this.selectedCar.userVehicleId);
    }
    this.selectedCar = undefined;
    this.selectedTrip = undefined;
    this.lastTripData = undefined;
    this.drawingMode = null;
    this.centerVehicle = { lat: undefined, lng: undefined };
    for (let c of this.availableCars) {
      c["isInfoWindowOpen"] = false;
      if (c.userVehicleId == car.userVehicleId) {
        if (isForceSelect) {
          c.selected = true;
        } else {
          c.selected = !car.selected;
        }
      } else {
        c.selected = false;
      }
      if (c.selected) {
        this.selectedCar = c;
        this.selectedCar.isInfoWindowOpen = true;
        this.socketIoService.joinRoom(car.userVehicleId);
      }
    }
    if (this.selectedCar) {
      this.getVehicleActiveAlerts();
      this.getUserLastTrip();
      // this.getUserDrivingAnalytics();
      // this.getLiveLocationDetails();
      setTimeout(() => {
        this.centerVehicle = {
          lat: +this.selectedCar.latitude,
          lng: +this.selectedCar.longitude,
        };
      }, 500);

      this.isVehicleAlertsCardCollapsed = true;
    }
  }

  getUserLastTrip() {
    this.dashboardService
      .getUserTrips(this.selectedCar.user.userId, this.lastTripSearch)
      .subscribe((res: any) => {
        this.lastTripData = res.userTrips[0];
        if (!this.lastTripData?.tripEnded) {
          this.lastTripData["safetyScore"] = (
            (this.lastTripData.safeKm / this.lastTripData.tripDistance) *
            100
          ).toFixed(2);
        } else {
          console.log("Fetching valid trips");
          this.dashboardService
            .getUserTrips(this.selectedCar.user.userId, {
              ...this.tripsSearch,
              page: 0,
              isBasic: false,
              size: 1,
            })
            .subscribe(
              (res: any) => {
                this.lastTripData = res.userTrips[0];
                if (
                  this.lastTripData &&
                  this.lastTripData.tripEnded &&
                  this.lastTripData.valid &&
                  this.lastTripData.tripDistance &&
                  this.lastTripData.safeKm
                ) {
                  this.lastTripData["safetyScore"] = (
                    (this.lastTripData.safeKm /
                      this.lastTripData.tripDistance) *
                    100
                  ).toFixed(2);
                }
              },
              (error) => {
                console.error(error);
              }
            );
        }
      });
  }

  public getAllDriverVehicles(
    hideLoader?: boolean,
    isNotUpdateCenter?: boolean
  ) {
    if (!hideLoader) {
      // setTimeout(() => this.spinner.show(), 500);
    }
    this.dashboardService
      .getAllDriversVehicles(this.driverVehiclesSearch)
      .subscribe(
        (res: any) => {
          this.availableCars = res.userVehicles;
          console.log(this.availableCars);
          if (this.availableCars?.length) {
            if (!isNotUpdateCenter) {
              let latitude = 0;
              let longitude = 0;
              let latlngAvailableCars = 0;
              this.availableCars.forEach((av) => {
                if (av.latitude && av.longitude) {
                  latitude += +av.latitude;
                  longitude += +av.longitude;
                  latlngAvailableCars += 1;
                  // this.getLiveLocationDetails(av);
                }
              });

              this.centerVehicle = {
                lat: latitude / latlngAvailableCars,
                lng: longitude / latlngAvailableCars,
              };
              if (this.queryVehicleId) {
                for (let av of this.availableCars) {
                  if (av.userVehicleId == this.queryVehicleId) {
                    this.queryVehicleId = "";
                    this.onCarCheckBoxClick(av);
                  }
                }
              }
            }
            this.spinner.hide();
            if (!hideLoader && this.isFullScreenEnabled) {
              this._snackBar.open("Fullscreen mode Enabled");
              setTimeout(() => this._snackBar.dismiss(), 4000);
            }
          } else {
            this.spinner.hide();
            this.alertService.danger("No Vehicles Found");
          }
        },
        (error) => {
          console.error(error);
          this.alertService.danger(error.message ? error.message : error);
        }
      );
  }

  onAvailableCarsMarkerClick(car: any) {
    console.log(car);
  }

  private getVehicleActiveAlerts() {
    this.selectedVehicleAlerts = [];
    this.dashboardService
      .getVehicleAlerts(
        this.selectedCar.userVehicleId,
        this.vehicleAlertsSearch
      )
      .subscribe(
        (res: any) => {
          if (res.alerts && res.alerts.length) {
            this.selectedVehicleAlerts = [res.alerts[0]];
          }
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  getStopDuration(t0) {
    let d = new Date().getTime() - new Date(t0).getTime();
    let weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
    let days = Math.floor(d / 1000 / 60 / 60 / 24 - weekdays * 7);
    let hours = Math.floor(d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24);
    let minutes = Math.floor(
      d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60
    );
    let seconds = Math.floor(
      d / 1000 -
        weekdays * 7 * 24 * 60 * 60 -
        days * 24 * 60 * 60 -
        hours * 60 * 60 -
        minutes * 60
    );
    let t = {};
    ["weekdays", "days", "hours", "minutes", "seconds"].forEach((q) => {
      if (eval(q) > 0) {
        t[q] = eval(q);
      }
    });
    return t;
  }

  private getUserDrivingAnalytics() {
    this.dashboardService
      .getUserDrivingAnalytics(this.selectedCar.user.userId)
      .subscribe(
        (res: any) => {
          this.selectedVehicleUserDrivingAnalytics = res.userDrivingAnalytics;
          if (
            this.selectedVehicleUserDrivingAnalytics.totalSafeTripsDistance &&
            this.selectedVehicleUserDrivingAnalytics.totalDistanceTravelledInKm
          ) {
            this.selectedVehicleUserDrivingAnalytics.safetyScore = Math.round(
              (this.selectedVehicleUserDrivingAnalytics.totalSafeTripsDistance /
                this.selectedVehicleUserDrivingAnalytics
                  .totalDistanceTravelledInKm) *
                100
            );
          }
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  public getLiveLocationDetails(car?: any) {
    this.dashboardService
      .getLocationDetails(
        car ? car.latitude : this.selectedCar.latitude,
        car ? car.longitude : this.selectedCar.longitude
      )
      .subscribe(
        (res: any) => {
          if (car) {
            car.locationDetails = res.locationDetails.locationDetails;
            return car.locationDetails;
          } else {
            this.selectedVehicleLiveLocation =
              res.locationDetails.locationDetails;
          }
        },
        (error) => {
          console.error(error);
          this.alertService.danger(error.message ? error.message : error);
        }
      );
  }

  openFullscreen() {
    this.isFullScreenEnabled = true;

    this.navElem = document.getElementById("page-topbar");
    this.navElem.style.display = "none";
    let pc = document.getElementsByClassName("page-content")[0];
    pc["style"].padding = 0;
    let amg_map = document.getElementById("agm-map");
    amg_map.style.height = "100vh";

    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  } /* Close fullscreen */
  isShowGeoFencing: boolean = false;
  drawing: any;
  drawingMode: any = null;
  // agmPolygonPaths: any = [];
  selectedCircleRegion: any;

  closeFullscreen() {
    this.isFullScreenEnabled = false;
    this.navElem.style.display = "block";
    let pc = document.getElementsByClassName("page-content")[0];
    pc["style"].padding =
      "calc(70px + 24px) calc(24px / 2) 60px calc(24px / 2)";
    let amg_map = document.getElementById("agm-map");
    amg_map.style.height = "650px";

    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  private getVehicleDrivingAlerts() {
    this.spinner.show();
    this.selectedVehicleDrivingAlerts = [];
    this.dashboardService
      .getDrivingAlertOfVehicle(this.drivingAlertsSearch)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          if (res.drivingAlerts && res.drivingAlerts.length) {
            res.drivingAlerts.forEach((da) => {
              let alert = JSON.parse(da.data);
              alert["label"] = alert.alert_Type
                .split(" ")
                .map((a) => a.charAt(0).toUpperCase())
                .join("");
              da["alert"] = alert;
              this.selectedVehicleDrivingAlerts.push(da);
            });
          }
        },
        (error) => {
          console.error(error);
          this.alertService.danger(error.message ? error.message : error);
        }
      );
  }

  onTabChange(index: number) {
    console.log(index);
    if (index == 1) {
      if (!this.selectedCar) {
        this.matTabGroup.selectedIndex = 0;
        this._snackBar.open("Please Select a Car");
        setTimeout(() => this._snackBar.dismiss(), 4000);
      } else {
        this.drivingAlertsSearch.vehicleId = this.selectedCar.userVehicleId;
        this.getVehicleDrivingAlerts();
      }
    } else if (index == 2) {
      if (!this.selectedCar) {
        this.matTabGroup.selectedIndex = 0;
        this._snackBar.open("Please Select a Car");
        setTimeout(() => this._snackBar.dismiss(), 4000);
      } else {
        //  get trips
        this.tripsSearch.vehicleId = this.selectedCar.userVehicleId;
        this.getUserTrips();
      }
    }
  }

  onDrivingAlertsDateRangeChange() {
    if (
      this.drivingAlertsDateRange.value.start &&
      this.drivingAlertsDateRange.value.end
    ) {
      this.drivingAlertsSearch.periodFrom = this.datePipe.transform(
        new Date(this.drivingAlertsDateRange.value.start),
        "yyyy-MM-dd"
      );
      this.drivingAlertsSearch.periodTo = this.datePipe.transform(
        new Date(this.drivingAlertsDateRange.value.end),
        "yyyy-MM-dd"
      );
      this.getVehicleDrivingAlerts();
    }
  }

  private getUserTrips() {
    this.spinner.show();
    this.dashboardService
      .getUserTrips(this.selectedCar.user.userId, this.tripsSearch)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.selectedCarTripsTotalRecord = res.totalRecords;
          this.selectedCarTrips = res.basicTripsData;
          this.selectedCarTrips.forEach((t) => {
            t["safetyScore"] = +((t.safeKm / t.distanceCovered) * 100).toFixed(
              2
            );
          });
          console.log(this.selectedCarTrips)
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  getTripDuration(trip: any) {
    let date = new Date(trip.startDate).getTime();
    let date2 = new Date(trip.endDate).getTime();
    let hourDiff = date2 - date; //in ms
    let secDiff = hourDiff / 1000; //in s
    let minDiff = hourDiff / 60 / 1000; //in minutes
    let hDiff = hourDiff / 3600 / 1000; //in hours
    let humanReadable = {};
    humanReadable["hours"] = Math.floor(hDiff);
    humanReadable["minutes"] = Math.round(
      minDiff - 60 * humanReadable["hours"]
    );
    return humanReadable;
  }

  onTripClick(trip: any) {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.selectedTrip = trip;
    this.drawingMode = null;

    if (this.selectedTrip.endLat) {
      this.selectedTrip["isOnGoingTrip"] = false;
    } else {
      this.selectedTrip["isOnGoingTrip"] = true;
      if (!this.sub) {
        this.sub = Observable.interval(120000).subscribe((val) => {
          this.getTripDetails(trip.tripId);
        });
      }
    }
    this.getTripLatlongs(trip.tripId);
    this.getTripDrivingAlerts(trip.tripId);
    this.getTripVehicleAlerts(trip.tripId);
  }

  private getTripDetails(tripId: string) {
    this.dashboardService
      .getTripDetailsById(tripId, this.tripsSearch)
      .subscribe(
        (res: any) => {
          this.selectedTrip = res.basicTripsData[0];
          if (this.selectedTrip.endLat) {
            this.selectedTrip["isOnGoingTrip"] = false;
          } else {
            this.selectedTrip["isOnGoingTrip"] = true;
            if (!this.sub) {
              this.sub = Observable.interval(120000).subscribe((val) => {
                this.getTripDetails(tripId);
              });
            }
          }
          this.getTripLatlongs(tripId);
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  private getTripLatlongs(tripId: string) {
    this.tripLatLongs = [];
    this.spinner.show();
    this.dashboardService
      .getTripLatlongs(tripId)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          let data: any[] = res.data;
          data.push({
            location: {
              lat: this.selectedTrip.startLat,
              lng: this.selectedTrip.startLong,
            },
          });
          data.push({
            location: {
              lat: this.selectedTrip.endLat,
              lng: this.selectedTrip.lnendLong,
            },
          });
          if (data && data.length > 0) {
            data.forEach((d) =>
              this.tripLatLongs.push({
                location: {
                  lat: +d.latitude,
                  lng: +d.longitude,
                  createdOn: d.createdOn,
                },
              })
            );
          }

          // this.initMap();
          this.flightPlanCoordinates = [];
          this.tripLatLongs.forEach((tl) => {
            if (tl.location.lat && tl.location.lng) {
              this.flightPlanCoordinates.push({
                lat: tl.location.lat,
                lng: tl.location.lng,
                createdOn: tl.location.createdOn,
              });
            }
          });
          if (this.selectedTrip["isOnGoingTrip"]) {
            if (
              this.flightPlanCoordinates &&
              this.flightPlanCoordinates.length
            ) {
              console.log(
                this.flightPlanCoordinates[
                  this.flightPlanCoordinates.length - 1
                ]
              );
              this.selectedTripLiveLocationDetails = {
                lat: this.flightPlanCoordinates[
                  this.flightPlanCoordinates.length - 1
                ].lat,
                lng: this.flightPlanCoordinates[
                  this.flightPlanCoordinates.length - 1
                ].lng,
                createdOn:
                  this.flightPlanCoordinates[
                    this.flightPlanCoordinates.length - 1
                  ].createdOn,
              };
              console.log(this.selectedTripLiveLocationDetails);
              // this.getLiveLocationDetails({
              //   latitude: this.selectedTripLiveLocationDetails.lat,
              //   longitude: this.selectedTripLiveLocationDetails.lng
              // });
              this.centerVehicle = {
                lat: +this.selectedTripLiveLocationDetails.lat,
                lng: +this.selectedTripLiveLocationDetails.lng,
              };
            }
          } else {
            this.centerVehicle = {
              lat: +this.selectedTrip.endLat,
              lng: +this.selectedTrip.endLong,
            };
          }
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  private getTripDrivingAlerts(tripId: string) {
    this.selectedTripDrivingAlerts = [];
    this.dashboardService.getTripDrivingAlerts(tripId).subscribe(
      (res: any) => {
        if (res.drivingAlerts && res.drivingAlerts.length) {
          res.drivingAlerts.forEach((da) => {
            let alert = JSON.parse(da.data);
            let name = alert.alert_Type
              .split(" ")
              .map((a) => a.charAt(0).toUpperCase())
              .join("");
            alert["label"] = name;
            this.selectedTripDrivingAlerts.push(alert);
          });
        }
      },
      (error1) => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  private getTripVehicleAlerts(tripId: string) {
    this.selectedTripVehicleAlerts = [];
    this.dashboardService.getTripVehicleAlerts(tripId).subscribe(
      (res: any) => {
        this.selectedTripVehicleAlerts = res.alerts;
      },
      (error1) => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  isAnyUpdateOfCarInFiveMin(selectedCar: any) {
    let now = new Date();
    let lastUpdate = new Date(selectedCar.lastUpdatedOn);
    let diffMs = now.getTime() - lastUpdate.getTime();
    let diffMin = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    return diffMin < 5;
  }

  onTripDateRangeChange() {
    if (this.tripsDateRange.value.start && this.tripsDateRange.value.end) {
      this.tripsSearch.periodFrom = this.datePipe.transform(
        new Date(this.tripsDateRange.value.start),
        "yyyy-MM-dd"
      );
      this.tripsSearch.periodTo = this.datePipe.transform(
        new Date(this.tripsDateRange.value.end),
        "yyyy-MM-dd"
      );
      this.getUserTrips();
    }
  }

  onDrawingComplete(ev: google.maps.Circle) {
    this.selectedCircleRegion = {
      center: { lat: ev.getCenter().lat(), lng: ev.getCenter().lng() },
      radius: ev.getRadius(),
    };
    // let overlay = ev.overlay;
    // let latlongs = [];
    // for (let a of overlay.getPath().getArray()) {
    //   latlongs.push({lat: a.lat(), lng: a.lng()});
    // }
    // this.agmPolygonPaths = latlongs;
    this.drawingMode = null;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "250px",
      data: { regNo: this.selectedCar.regNumber },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        // this.agmPolygonPaths = [];
        this.selectedCircleRegion = null;
      } else {
        let payload = {
          regNumber: this.selectedCar.regNumber,
          // geoFencingCoordinates: JSON.stringify({regionType: 'polygon', latlongs: latlongs})
          geoFencingCoordinates: JSON.stringify({
            regionType: "circle",
            center: this.selectedCircleRegion.center,
            radius: this.selectedCircleRegion.radius,
          }),
        };
        this.dashboardService
          .updateVehicle(this.selectedCar.userVehicleId, payload)
          .subscribe(
            (res: any) => {
              this.alertService.success(
                "Geo Fencing Added Successfully. You will get Alert when the Car Enters or Leaves the Region."
              );
              this.getAllDriverVehicles();
            },
            (error) => {
              console.error(error);
              this.alertService.danger(error.message ? error.message : error);
            }
          );
      }
    });
  }

  onCreateGeoFencingClick(car: any) {
    // this.agmPolygonPaths = [];
    this.selectedCircleRegion = null;
    this.onCarCheckBoxClick(car, true);
    this.isShowGeoFencing = true;
    this.drawingMode = "circle";
    this._snackBar.open("Drawing mode Enabled", "", { duration: 3000 });
  }

  onViewGeFencingRegionClick(car: any) {
    let payload = JSON.parse(car.geoFencingCoordinates);
    console.log(payload);
    this.selectedCircleRegion = {
      center: payload.center,
      radius: payload.radius,
    };
    // this.agmPolygonPaths = payload.latlongs;
  }

  onRemoveGeoFencingClick(car: any) {
    if (
      confirm("Are you sure want to remove Geo Fencing for " + car.regNumber)
    ) {
      // this.agmPolygonPaths = [];
      this.selectedCircleRegion = null;
      let payload = {
        regNumber: this.selectedCar.regNumber,
        isGeoFencingEnabled: false,
      };
      this.dashboardService.updateVehicle(car.userVehicleId, payload).subscribe(
        (res: any) => {
          this.alertService.success("Geo Fencing Has Been Removed.");
          this.getAllDriverVehicles();
        },
        (error) => {
          console.error(error);
          this.alertService.danger(error.message ? error.message : error);
        }
      );
    }
  }

  resetHeight() {
    // reset the body height to that of the inner browser
    let wrapper = document.getElementById("wrapper");
    let vMenu = document.getElementsByClassName("vertical-menu");
    if (vMenu && vMenu.length) {
      vMenu[0]["style"].height = window.innerHeight - 70 + "px";
      vMenu[0]["style"].maxHeight = window.innerHeight - 70 + "px";
    }
    wrapper.style.height = window.innerHeight + "px";
  }

  onVehicleAlertsCardToggleBtn() {
    this.isVehicleAlertsCardCollapsed = !this.isVehicleAlertsCardCollapsed;
    let e = document.getElementById("vehicle_alerts_table");
    if (this.isVehicleAlertsCardCollapsed) {
      e.style.height = "0";
    } else {
      e.style.height = "150px";
    }
    console.log(e.style.height);
  }

  onClearDateRangeClick() {
    this.drivingAlertsDateRange.get("start").setValue(undefined);
    this.drivingAlertsDateRange.get("end").setValue(undefined);
    this.drivingAlertsSearch.periodFrom = undefined;
    this.drivingAlertsSearch.periodTo = undefined;
    this.getVehicleDrivingAlerts();
  }
}
